import { render, staticRenderFns } from "./PracticeSumupUnitCurriculumEdit.vue?vue&type=template&id=c42537e2&scoped=true&"
import script from "./PracticeSumupUnitCurriculumEdit.vue?vue&type=script&lang=ts&"
export * from "./PracticeSumupUnitCurriculumEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeSumupUnitCurriculumEdit.vue?vue&type=style&index=0&id=c42537e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42537e2",
  null
  
)

export default component.exports